import { selectors as UsersSelectors } from 'data/users'

export default function searchUsers(
  storeState,
  query = '',
  maxItemsOnEmptyQuery = 5
) {
  const users =
    query === ''
      ? UsersSelectors.getUsersWithoutCurrent(storeState, {
          filterOutArchived: true,
          filterOutInvited: true,
        })
          .toList()
          .take(maxItemsOnEmptyQuery)
          .toJS()
      : UsersSelectors.searchUsers(storeState, query).toJS()
  return Promise.resolve(users)
}
